import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { usePanelAccess } from '../../context/PanelAccessContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../core/store/store';
import {
  canPanelViewInterventionsCta,
  canPanelManageInterventions,
} from '../../panelAccess/panelRoleAccess';

const PanelScenariosPage: React.FC = () => {
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { hasAccessToSection, loading } = usePanelAccess();
  const location = useLocation();
  const roleId = currentUser?.roles_id ?? 0;

  if (loading || !currentUser) return null;

  const canCta    = hasAccessToSection('interventions')        || canPanelViewInterventionsCta(roleId);
  const canManage = hasAccessToSection('interventions_manage') || canPanelManageInterventions(roleId);

  const tabs = [
    { to: '/panel/scenarios/cta',   can: canCta    },
    { to: '/panel/scenarios/gerer', can: canManage },
  ];

  const visibleTabs = tabs.filter((t) => t.can);
  if (!visibleTabs.length) return <Navigate to="/panel/dashboard" replace />;

  const base = '/panel/scenarios';
  if (location.pathname === base || location.pathname === `${base}/`) {
    return <Navigate to={visibleTabs[0].to} replace />;
  }

  return <Outlet />;
};

export default PanelScenariosPage;
